<template>
  <div class="switch-container mr-2">
    <div class="center con-switch">
      <vs-switch
        class="vs-switch-success"
        @click="ChangeStatus(params.data.status, params.data.id, params.rowIndex, 'Lesson')"
        v-model="actiobBtn"
      />
    </div>
  </div>
</template>
<script>

import {StatusMixin} from './mixins/StatusMixin'
export default {
  mounted () {
    this.actiobBtn = this.params.data.status
  },
  mixins:[StatusMixin],
  data () {
    return {
      actiobBtn: false
    }
  },
  methods: {
  }
}
</script>
